import { ExclamationCircleIcon } from '@heroicons/react/20/solid';

import { ButtonV2, cn, Typography } from 'src/shared/components/ui';

interface UploadFailedNoticeProps {
  /** User-facing reason the upload failed. */
  error?: string;
  /** Upload the file again. */
  onRetry: () => void;
  /** Drop the file instead of retrying. */
  onRemove: () => void;
  className?: string;
}

/**
 * Inline notice for a file whose upload failed, letting the user choose between
 * retrying the upload and removing the file.
 */
export function UploadFailedNotice({
  error,
  onRetry,
  onRemove,
  className
}: UploadFailedNoticeProps) {
  return (
    <div
      className={cn('flex flex-col gap-1.5 mt-1', className)}
      // The notice sits inside clickable rows (e.g. opening the caption editor)
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-start gap-1.5">
        <ExclamationCircleIcon className="size-3.5 text-danger mt-0.5 flex-shrink-0" />
        <Typography variant="body-2" className="text-danger">
          {error || 'Upload failed. Please try again.'}
        </Typography>
      </div>
      <div className="flex items-center gap-2">
        <ButtonV2
          color="tertiary"
          size="sm"
          className="h-7 px-3"
          onPress={onRetry}
        >
          Retry
        </ButtonV2>
        <ButtonV2
          color="fourth"
          size="sm"
          className="h-7 px-3"
          onPress={onRemove}
        >
          Remove
        </ButtonV2>
      </div>
    </div>
  );
}
